import { NewUser } from './NewUser';
import { TableListUser } from './TableListuser';

export const Configurar = () => {
  return (
    <div className="mt-4 container">
      <div className="row mt-4">
        <h1>Configurar</h1>
        <div className="col-2 mt-4">
          <NewUser />
        </div>
        <div className="col-10 mt-4"></div>
        <div className="mt-4">
          <TableListUser />
        </div>
      </div>
    </div>
  );
};
